import "./style.css";
import MistPlayer from "./MistPlayer";
import CanvasPlayer from "./CanvasPlayer";

const Player = (props) => {
  if (!props.host || props.host == "") {
    return;
  }
  return (
    <div className="row-container maximize">
      {props.useMistPlayer && !props.hidePlayer ? (
        <MistPlayer
          baseUri={"https://" + props.host + props.path}
          streamName={props.streamName}
        />
      ) : null}
      {!props.useMistPlayer && !props.hidePlayer ? (
        <CanvasPlayer
          uri={
            "wss://" + props.host + props.path + "webrtc/" + props.streamName
          }
        />
      ) : null}
    </div>
  );
};

export default Player;
